<template>
  <div
    class="quick-vacancy"
    :class="bem('quick-vacancy', { banned, responded })"
  >
    <div class="quick-vacancy__container">
      <div class="quick-vacancy__top">
        <div
          class="quick-vacancy__accuracy-label"
          :class="bem('quick-vacancy__accuracy-label', { banned })"
        >
          Совпадение <strong>{{ Math.round(vacancy.recommendationAccuracyPercent) }}%</strong>
        </div>

        <div class="quick-vacancy__header">
          <div class="quick-vacancy__info">
            <div class="quick-vacancy__company__name">
              <BasicLink
                :title="vacancy.company.title"
                :href="vacancy.company.href"
                appearance="dark"
                target="_blank"
              />
              <CompanyIcons :company="vacancy.company" />
              <span
                v-if="vacancy.company.rating"
                class="quick-vacancy__company-rating"
              >
                <CompanyRating :rating="vacancy.company.rating" />
              </span>
            </div>
            <div class="quick-vacancy__title">
              <BasicLink
                :title="vacancy.title"
                :href="vacancy.href"
                appearance="dark"
                target="_blank"
              />
            </div>
          </div>
          <BasicAvatar
            class="quick-vacancy__company-logo"
            :image="companyAvatar"
            size="medium"
            :href="vacancy.company.href"
            target="_blank"
          />
        </div>

        <div class="quick-vacancy__meta">
          <VacancyMeta
            :vacancy="vacancy"
            no-links
          />
        </div>
        <div
          v-if="vacancy.salary"
          class="quick-vacancy__salary"
        >
          <BasicSalary :salary="vacancy.salary" />
        </div>
      </div>

      <div class="quick-vacancy__requirements">
        <div
          v-if="divisionsAndQualification"
          class="quick-vacancy__divisions"
        >
          <InlineList
            :items="divisionsAndQualification"
            separator="comma"
            v-slot="{ item }"
          >
            <span v-text="item.title"></span>
          </InlineList>
        </div>
        <div class="quick-vacancy__skills">
          <InlineList
            :items="vacancy.skills"
            separator="comma"
            v-slot="{ item }"
          >
            <span v-text="item.title"></span>
          </InlineList>
        </div>
      </div>

      <div class="quick-vacancy__footer">
        <TransitionFade mode="out-in">
          <div
            v-if="responded || banned"
            key="result"
            class="quick-vacancy__result"
            :class="bem('quick-vacancy__result', { banned, responded })"
          >
            <SvgIcon v-if="responded" icon="check-circle" size="24" />
            <span v-if="responded">Отклик отправлен</span>
            <span v-else>Вакансия не интересна</span>
          </div>
          <div
            v-else
            key="controls"
            class="quick-vacancy__controls"
          >
            <BasicButton
              appearance="secondary"
              :disabled="loading"
              size="l"
              @click="$emit('ban', vacancy)"
            >
              Не интересно
            </BasicButton>
            <BasicButton
              appearance="primary"
              :disabled="loading"
              size="l"
              @click="$emit('respond', vacancy)"
            >
              Откликнуться
            </BasicButton>
          </div>
        </TransitionFade>
      </div>
    </div>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';

  import BasicAvatar from 'src/components/BasicAvatar/BasicAvatar.vue';
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicLink from 'src/components/BasicLink/BasicLink.vue';
  import BasicSalary from 'src/components/BasicSalary/BasicSalary.vue';
  import CompanyIcons from 'src/components/companies/CompanyIcons/CompanyIcons.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import InlineList from 'src/components/InlineList/InlineList.vue';
  import CompanyRating from 'src/components/resume/CompanyRating/CompanyRating.vue';
  import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';
  import VacancyMeta from 'src/components/vacancies/VacancyMeta/VacancyMeta.vue';

  export default {
    name: 'QuickVacancy',
    components: {
      TransitionFade,
      SvgIcon,
      BasicLink,
      BasicAvatar,
      BasicButton,
      InlineList,
      BasicSalary,
      VacancyMeta,
      CompanyIcons,
      CompanyRating
    },
    props: {
      vacancy: {
        type: Object,
        required: true,
      },
      responded: Boolean,
      banned: Boolean,
      loading: Boolean,
    },
    emits: ['respond', 'ban'],
    methods: {
      bem,
    },
    computed: {
      divisionsAndQualification() {
        return this.vacancy.salaryQualification
          ? this.vacancy.divisions.concat(this.vacancy.salaryQualification)
          : this.vacancy.divisions;
      },
      companyAvatar() {
        return {
          src: this.vacancy.company.logo.src,
          alt: `Логотип компании «${this.vacancy.company.title}»`
        }
      }
    },
  };
</script>
